<template>
    <div class="mobile-navigation-panel" :class="{ 'is-open': mobileNavStore.getOpendState }">
        <header class="mobile-navigation-panel__header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="controls">
                            <button
                                @click="mobileNavStore.toggleNav(false)"
                                type="button"
                                class="btn-nav--round">
                                <svgComponent
                                    :width="24"
                                    :height="24"
                                    class-name="icon-close"
                                    icon-name="icon-close"></svgComponent>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <section class="mobile-navigation-panel__body">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <header class="header">
                            <div class="h3">Menu</div>

                            <select
                                class="mobile-select"
                                v-model="mobileNavStore.navigationType"
                                @change="changeMobileNav()">
                                <option disabled :value="mobileNavStore.navigationType">
                                    {{ mobileNavStore.navigationType }}
                                </option>
                                <option
                                    v-for="(link, index) in props.navigation"
                                    :key="`mobileselect-${link.Type}-${index}`">
                                    {{ link.Type }}
                                </option>
                            </select>
                        </header>

                        <nav
                            class="nav-list"
                            v-for="(navigationItem, index) in cNavigation"
                            :key="`mobile-${index}`">
                            <template
                                v-for="(link, index) in navigationItem.NavigationLinks"
                                :key="`mobile-${link.Text}-${index}`">
                                <template v-if="link.SubItems.length > 0">
                                    <nav-list :item="link"></nav-list>
                                </template>
                                <template v-else>
                                    <a
                                        :href="link.MainLink.Url"
                                        :target="link.MainLink.Target"
                                        :class="{ 'is-active': link.MainLink.Active }"
                                        class="link"
                                        >{{ link.MainLink.Text }}</a
                                    >
                                </template>
                            </template>
                        </nav>
                    </div>
                </div>
            </div>
        </section>

        <footer class="mobile-navigation-panel__footer">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <nav class="nav-list">
                            <a :href="secondaryNav.Url" :target="secondaryNav.Target" class="link">
                                {{ secondaryNav.Text }}
                                <svgComponent
                                    :width="16"
                                    :height="16"
                                    class-name="icon-arrow-right"
                                    icon-name="arrow-right"></svgComponent>
                            </a>
                        </nav>
                        <div class="controls">
                            <a
                                :href="knhsbutton.Url"
                                :target="knhsbutton.Target"
                                class="btn-default btn-default--1 btn-w100"
                                >{{ knhsbutton.Text }}</a
                            >

                            <a
                                :href="contactbutton.Url"
                                :target="contactbutton.Target"
                                class="btn-default btn-default--3 btn-w100">
                                <svgComponent
                                    :width="24"
                                    :height="24"
                                    class-name="icon-person"
                                    icon-name="icon-person-nav"></svgComponent>
                                <span>{{ contactbutton.Text }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { INavigation, ILink, IButtonLink } from '../../../interfaces/Navigation';
import svgComponent from '../../../components/svgComponent.vue';
import { useMobileNavStore } from '../store/mobile-nav.store';
import navList from './navList.component.vue';

const props = defineProps<{
    navigation: INavigation[];
    secondaryNav: ILink;
    knhsbutton: IButtonLink;
    contactbutton: IButtonLink;
}>();

function changeMobileNav() {
    if (cNavigation.value[0].PageUrl) {
        window.location.href = cNavigation.value[0].PageUrl;
    }
}

const mobileNavStore = useMobileNavStore();

console.log('mobile navigation', props.navigation);

const cNavigation = computed(() => {
    return props.navigation.filter((x) => x.Type === mobileNavStore.navigationType);
});
</script>
